import React, { Dispatch, SetStateAction } from "react";
import { Button, DialogNew } from "@optimizely/axiom";
import { ActivationStatusesTable } from "./ActivationStatusesTable";

export const ActivationStatusesModal = ({
    closeText = "Cancel",
    showModal
}: {
    closeText?: string;
    showModal: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <DialogNew
            data-cy="activation-statuses-modal"
            footerButtonList={[
                // eslint-disable-next-line
                <Button style="highlight" onClick={() => showModal(false)}>
                    {closeText}
                </Button>
            ]}
            title="Activation Statuses"
            hasCloseButton
            hasOverlay
            onClose={() => showModal(false)}
        >
            <ActivationStatusesTable />
        </DialogNew>
    );
};

ActivationStatusesModal.displayName = "ActivationStatusesModal";
